// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Container,
//   Table,
//   Button,
//   Modal,
//   Form,
//   Alert,
//   Badge,
//   Spinner,
//   Pagination,
// } from "react-bootstrap";
// import { FaPlus, FaEdit, FaTrash, FaSave, FaSync } from "react-icons/fa";

// export default function ServicesAdmin() {
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [message, setMessage] = useState({ type: "", text: "" });
//   // --- Pagination State ---
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 20;
//   // Form State
//   const [formData, setFormData] = useState({
//     id: "",
//     title: "",
//     description: "",
//     icon_name: "FaCogs",
//     category: "service",
//   });

//   const API_URL = "https://radheyelectrical.com/api/services_page.php";

//   const fetchServices = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
//       setServices(data);
//     } catch (err) {
//       // Note: If showAlert is defined inside the component,
//       // it should also be memoized or moved outside.
//       showAlert("danger", "Failed to load services.");
//     } finally {
//       setLoading(false);
//     }
//   }, [API_URL]); // 3. Dependencies: only re-create if API_URL changes

//   // 4. Update useEffect to include fetchServices in the dependency array
//   useEffect(() => {
//     fetchServices();
//   }, [fetchServices]);

//   const showAlert = (type, text) => {
//     setMessage({ type, text });
//     setTimeout(() => setMessage({ type: "", text: "" }), 3000);
//   };
//   // --- Pagination Logic ---
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = services.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(services.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     window.scrollTo(0, 0); // Optional: scroll to top when page changes
//   };
//   // Open modal for adding
//   const handleAddShow = () => {
//     setIsEditing(false);
//     setFormData({
//       id: "",
//       title: "",
//       description: "",
//       icon_name: "FaCogs",
//       category: "service",
//     });
//     setShowModal(true);
//   };

//   // Open modal for editing
//   const handleEditShow = (service) => {
//     setIsEditing(true);
//     setFormData(service);
//     setShowModal(true);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const method = isEditing ? "PUT" : "POST";

//     try {
//       const res = await fetch(API_URL, {
//         method: method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });
//       const result = await res.json();

//       if (result.message) {
//         showAlert("success", result.message);
//         setShowModal(false);
//         fetchServices();
//       } else {
//         throw new Error(result.error);
//       }
//     } catch (err) {
//       showAlert("danger", err.message);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this service?"))
//       return;

//     try {
//       const res = await fetch(API_URL, {
//         method: "DELETE",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id }),
//       });
//       const result = await res.json();
//       showAlert("warning", result.message);
//       fetchServices();
//     } catch (err) {
//       showAlert("danger", "Delete failed.");
//     }
//   };

//   return (
//     <Container className="py-5">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <div>
//           <h2 className="fw-bold text-dark">Service Management</h2>
//           <p className="text-muted">
//             Manage the precision testing services shown on the website.
//           </p>
//         </div>
//         <Button
//           variant="primary"
//           onClick={handleAddShow}
//           className="rounded-pill px-4"
//         >
//           <FaPlus className="me-2" /> Add New Service
//         </Button>
//       </div>

//       {message.text && <Alert variant={message.type}>{message.text}</Alert>}

//       <div className="bg-white shadow-sm rounded-4 overflow-hidden">
//         <Table responsive hover className="mb-0 align-middle">
//           <thead className="bg-light">
//             <tr>
//               <th className="px-4">Title</th>
//               <th>Category</th>
//               <th>Icon</th>
//               <th>Description</th>
//               <th className="text-end px-4">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="5" className="text-center py-5">
//                   <Spinner animation="border" variant="primary" />
//                 </td>
//               </tr>
//             ) : (
//               currentItems.map((s) => (
//                 <tr key={s.id}>
//                   <td className="px-4 fw-bold text-primary">{s.title}</td>
//                   <td>
//                     <Badge bg="info">{s.category}</Badge>
//                   </td>
//                   <td>
//                     <code>{s.icon_name}</code>
//                   </td>
//                   <td
//                     className="text-muted small"
//                     style={{ maxWidth: "300px" }}
//                   >
//                     {s.description.substring(0, 60)}...
//                   </td>
//                   <td className="text-end px-4">
//                     <Button
//                       variant="link"
//                       className="text-dark me-2"
//                       onClick={() => handleEditShow(s)}
//                     >
//                       <FaEdit />
//                     </Button>
//                     <Button
//                       variant="link"
//                       className="text-danger"
//                       onClick={() => handleDelete(s.id)}
//                     >
//                       <FaTrash />
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </Table>
//       </div>
//       {/* --- Pagination Controls --- */}
//       {totalPages > 1 && (
//         <div className="d-flex justify-content-center mt-4">
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />

//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}

//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </div>
//       )}
//       {/* --- ADD/EDIT MODAL --- */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//         <Form onSubmit={handleSubmit}>
//           <Modal.Header closeButton>
//             <Modal.Title>
//               {isEditing ? "Edit Service" : "Add New Service"}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form.Group className="mb-3">
//               <Form.Label>Service Title</Form.Label>
//               <Form.Control
//                 type="text"
//                 required
//                 value={formData.title}
//                 onChange={(e) =>
//                   setFormData({ ...formData, title: e.target.value })
//                 }
//               />
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Icon Name (React Icon Class)</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="e.g. FaBolt"
//                 value={formData.icon_name}
//                 onChange={(e) =>
//                   setFormData({ ...formData, icon_name: e.target.value })
//                 }
//               />
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Full Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={4}
//                 required
//                 value={formData.description}
//                 onChange={(e) =>
//                   setFormData({ ...formData, description: e.target.value })
//                 }
//               />
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setShowModal(false)}>
//               Cancel
//             </Button>
//             <Button variant="primary" type="submit">
//               {isEditing ? (
//                 <>
//                   <FaSync className="me-2" /> Update
//                 </>
//               ) : (
//                 <>
//                   <FaSave className="me-2" /> Save Service
//                 </>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>
//     </Container>
//   );
// }
import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Table,
  Button,
  Modal,
  Form,
  Alert,
  Badge,
  Spinner,
  Pagination,
  InputGroup,
} from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaSave, FaSync } from "react-icons/fa";
// Import all icons to allow dynamic rendering by string name
import * as FontAwesome from "react-icons/fa";

export default function ServicesAdmin() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Form State
  const initialFormState = {
    id: "",
    title: "",
    description: "",
    icon_name: "FaCogs",
    category: "service",
  };
  const [formData, setFormData] = useState(initialFormState);

  const API_URL = "https://radheyelectrical.com/api/services_page.php";

  // Helper to render icon dynamically from string
  const DynamicIcon = ({ iconName, ...props }) => {
    const Icon = FontAwesome[iconName];
    return Icon ? (
      <Icon {...props} />
    ) : (
      <FontAwesome.FaQuestionCircle {...props} />
    );
  };

  const showAlert = useCallback((type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: "", text: "" }), 4000);
  }, []);

  const fetchServices = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      // Ensure data is an array
      setServices(Array.isArray(data) ? data : []);
    } catch (err) {
      showAlert(
        "danger",
        "Failed to load services. Please check API connection."
      );
    } finally {
      setLoading(false);
    }
  }, [API_URL, showAlert]);

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = services.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(services.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleAddShow = () => {
    setIsEditing(false);
    setFormData(initialFormState);
    setShowModal(true);
  };

  const handleEditShow = (service) => {
    setIsEditing(true);
    setFormData({ ...service });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Logic: If editing, use PUT and include ID. If adding, use POST and remove ID.
    const method = isEditing ? "PUT" : "POST";
    const payload = isEditing ? formData : { ...formData, id: undefined };

    try {
      const res = await fetch(API_URL, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (res.ok || result.message) {
        showAlert(
          "success",
          isEditing
            ? "Service updated successfully!"
            : "Service added successfully!"
        );
        setShowModal(false);
        fetchServices();
      } else {
        throw new Error(result.error || "Operation failed");
      }
    } catch (err) {
      showAlert("danger", err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this service?"))
      return;

    try {
      const res = await fetch(API_URL, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      if (res.ok) {
        showAlert("warning", "Service deleted successfully.");
        fetchServices();
      }
    } catch (err) {
      showAlert("danger", "Delete failed.");
    }
  };

  return (
    <Container className="py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold text-dark border-start border-4 border-primary ps-3">
            Service Admin
          </h2>
          <p className="text-muted mb-0">
            Control the electrical service listings on your frontend.
          </p>
        </div>
        <Button
          variant="primary"
          onClick={handleAddShow}
          className="rounded-pill px-4 shadow-sm"
        >
          <FaPlus className="me-2" /> Add New Service
        </Button>
      </div>

      {message.text && (
        <Alert variant={message.type} className="shadow-sm">
          {message.text}
        </Alert>
      )}

      <div className="bg-white shadow-sm rounded-4 overflow-hidden border">
        <Table responsive hover className="mb-0 align-middle">
          <thead className="bg-light">
            <tr>
              <th className="px-4">Service Details</th>
              <th>Category</th>
              <th>Icon</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2 text-muted">Loading Services...</p>
                </td>
              </tr>
            ) : currentItems.length > 0 ? (
              currentItems.map((s) => (
                <tr key={s.id}>
                  <td className="px-4">
                    <div className="fw-bold text-dark">{s.title}</div>
                    <div
                      className="text-muted small text-truncate"
                      style={{ maxWidth: "250px" }}
                    >
                      {s.description}
                    </div>
                  </td>
                  <td>
                    <Badge bg="secondary" className="fw-normal">
                      {s.category}
                    </Badge>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="bg-light p-2 rounded me-2">
                        <DynamicIcon
                          iconName={s.icon_name}
                          className="text-primary"
                          size={20}
                        />
                      </div>
                      <code className="small text-muted">{s.icon_name}</code>
                    </div>
                  </td>
                  <td>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-2 border-0"
                      onClick={() => handleEditShow(s)}
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="border-0"
                      onClick={() => handleDelete(s.id)}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-4">
                  No services found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination className="justify-content-center mt-4">
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === currentPage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      )}

      {/* ADD/EDIT MODAL */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton className="bg-light">
            <Modal.Title className="fs-5 fw-bold">
              {isEditing ? (
                <>
                  <FaSync className="me-2 text-primary" /> Edit Service
                </>
              ) : (
                <>
                  <FaPlus className="me-2 text-success" /> Add New Service
                </>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="row">
              <div className="col-md-8">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Service Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. Transformer Testing"
                    required
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Category</Form.Label>
                  <Form.Select
                    value={formData.category}
                    onChange={(e) =>
                      setFormData({ ...formData, category: e.target.value })
                    }
                  >
                    <option value="service">Service</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">
                Icon Name (FontAwesome)
              </Form.Label>
              <InputGroup>
                <InputGroup.Text className="bg-white">
                  <DynamicIcon
                    iconName={formData.icon_name}
                    size={20}
                    className="text-primary"
                  />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="e.g. FaBolt, FaTools, FaPlug"
                  value={formData.icon_name}
                  onChange={(e) =>
                    setFormData({ ...formData, icon_name: e.target.value })
                  }
                />
              </InputGroup>
              <Form.Text className="text-muted">
                Use PascalCase (e.g., <strong>FaBolt</strong>). Preview is shown
                on the left.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-0">
              <Form.Label className="fw-bold">Full Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                required
                placeholder="Describe the service details..."
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button
              variant="link"
              className="text-muted text-decoration-none"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit" className="px-4">
              {isEditing ? (
                "Update Service"
              ) : (
                <>
                  <FaSave />
                  {" Save Service"}
                </>
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
}
